import { Component, Input, Output, EventEmitter, ContentChildren, QueryList, AfterViewInit, ViewChild } from "@angular/core";
import { MatTabGroup, MatTab } from "@angular/material";
import { CrewWizardTab } from "./crew-wizard-tab.component";

@Component({
    selector: "crew-wizard",
    template: require('./crew-wizard.component.html')
})
export class CrewWizard implements AfterViewInit {
    
    @Input()
    public isLoading: boolean;

    @Input()
    onDoneText: string;

    @Input()
    onDoneIcon: string;

    private tabCount: number;

    public selectedTabIndex: number = 0;

    public get isResultsTab(): boolean {
        return (this.tabCount - 1) === this.selectedTabIndex;
    }

    public get isLastTab(): boolean {
        return (this.tabCount - 2) === this.selectedTabIndex;
    }

    public get isFirstTab(): boolean {
        return this.selectedTabIndex === 0;
    }

    public nextTab() {
        if (this.isResultsTab) {
            return;
        }

        this.selectedTabIndex++;
    }

    public previousTab() {
        if (this.isFirstTab) {
            return;
        }

        this.selectedTabIndex--;
    }

    done() {
        this.onDone.emit();
        this.selectedTabIndex = this.tabCount - 1;
    }

    @Output()
    public onDone = new EventEmitter<void>();

    @ViewChild('tabGroup')
    tabGroup: MatTabGroup;

    @ContentChildren(CrewWizardTab)
    tabs: QueryList<CrewWizardTab>;

    // https://stackoverflow.com/questions/48840703/angular-material-tabs-not-working-with-wrapper-component
    public ngAfterViewInit() {
        const matTabsFromQueryList = this.tabs.map((tab) => tab.matTab);

        this.tabCount = matTabsFromQueryList.length;

        const list = new QueryList<MatTab>();
        list.reset([matTabsFromQueryList]);

        this.tabGroup._tabs = list;
        this.tabGroup.ngAfterContentInit();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/crew-wizard.component.ts